import { useRef, useEffect } from 'react';

type DrawFn = (
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  context: unknown,
) => void;

interface CanvasHelpers {
  predraw: (
    ctx: CanvasRenderingContext2D,
    canvas: HTMLCanvasElement,
    size: { height: number; width: number },
  ) => void;
  postdraw: () => void;
}

interface UseCanvasOptions {
  context: unknown;
  helpers: CanvasHelpers;
  size: { height: number; width: number };
}

export const useCanvas = (draw: DrawFn, options: UseCanvasOptions) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const {
    context,
    helpers,
    size: { height, width },
  } = options;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    helpers.predraw(ctx, canvas, { height, width });

    draw(ctx, width, height, context);

    helpers.postdraw();
  }, [draw, height, width]);

  return canvasRef;
};
